"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.walletconnect = exports.injected = exports.Provider = void 0;
const react_1 = require("react");
const injected_connector_1 = require("@web3-react/injected-connector");
const walletconnect_connector_1 = require("@web3-react/walletconnect-connector");
const react_redux_1 = require("react-redux");
let globalVariable;
const Provider = () => {
    const [existingProviders, setExistingProviders] = (0, react_1.useState)();
    const { providers } = (0, react_redux_1.useSelector)((state) => state.myTradesTransactions);
    (0, react_1.useEffect)(() => {
        if (providers) {
            const elements = Object.keys(providers);
            const existingProviders = elements
                .map((el) => providers[el])
                .filter(function (element) {
                return element !== undefined;
            });
            setExistingProviders(existingProviders);
        }
        globalVariable = existingProviders;
    }, [providers]);
    return existingProviders;
};
exports.Provider = Provider;
// const RPC_URLS = {
//   1: "https://mainnet.infura.io/v3/84842078b09946638c03157f83405213",
//   3: "https://ropsten.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161",
//   4: "https://rinkeby.infura.io/v3/84842078b09946638c03157f83405213",
//   5: "https://goerli.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161",
//   6: "https://kovan.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161",
//   42: "https://kovan.infura.io",
//   97: "https://data-seed-prebsc-1-s1.binance.org:8545/",
//   137: "https://polygon-rpc.com",
//   1287: "https://rpc.api.moonbase.moonbeam.network",
//   4002: "https://rpc.testnet.fantom.network/",
//   43113: "https://api.avax-test.network/ext/bc/C/rpc",
//   43114: "https://api.avax.network/ext/bc/C/rpc",
//   80001: "https://rpc-mumbai.maticvigil.com",
//   1666700000: "https://api.s0.b.hmny.io/",
// };
// import { Networks } from "ferrum-plumbing";
// const supportedNetworks: any = process.env
//   .REACT_APP_SUPPORTED_CHAINS_FOR_CONFIG || [
//   "ETHEREUM",
//   "BSC",
//   "POLYGON",
//   "RINKEBY",
//   "BSC_TESTNET",
//   "MUMBAI_TESTNET",
//   "AVAX_TESTNET",
//   "MOON_MOONBASE",
//   "AVAX_MAINNET",
//   "MOON_MOONRIVER",
// ];
// console.log({ supportedNetworks });
// const networks = supportedNetworks.split(",");
// let supportedChain: any = [];
// networks.forEach((network: string) => {
//   let chain = Networks.for(network.toString());
//   supportedChain = [...supportedChain, chain.chainId];
// });
exports.injected = new injected_connector_1.InjectedConnector({
    supportedChainIds: globalVariable,
    // supportedChainIds: [
    //   1, 3, 4, 5, 6, 42, 97, 137, 1285, 1287, 4002, 43113, 43114, 80001,
    //   1666700000,
    // ],
});
exports.walletconnect = new walletconnect_connector_1.WalletConnectConnector({
    rpc: {
        1: "https://mainnet.infura.io/v3/84842078b09946638c03157f83405213",
        3: "https://ropsten.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161",
        4: "https://rinkeby.infura.io/v3/84842078b09946638c03157f83405213",
        5: "https://goerli.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161",
        6: "https://kovan.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161",
        42: "https://kovan.infura.io",
        56: "https://bsc-dataseed.binance.org/",
        97: "https://data-seed-prebsc-1-s1.binance.org:8545/",
        137: "https://polygon-rpc.com",
        1287: "https://rpc.api.moonbase.moonbeam.network",
        4002: "https://rpc.testnet.fantom.network/",
        43113: "https://api.avax-test.network/ext/bc/C/rpc",
        43114: "https://api.avax.network/ext/bc/C/rpc",
        80001: "https://rpc-mumbai.maticvigil.com",
        1666700000: "https://api.s0.b.hmny.io/",
    },
    bridge: "https://bridge.walletconnect.org",
    qrcode: true,
});
//# sourceMappingURL=connectors.js.map